export const CONTENTFUL_DEFAULT_SORT = "-fields.datePublished";
export const CONTENTFUL_NEWS_DEFAULT_SORT = "-fields.date";
export const CONTENTFUL_REQUEST_LIMIT = 5;
export const CONTENTFUL_REQUEST_LIMIT_FIRST_PAGE = 6;
export const CONTENTFUL_REQUEST_LIMIT_PER_PAGE = 12;
export const CONTENTFUL_REQUEST_LIMIT_LARGE = 500;
export const CONTENTFUL_REQUEST_LIMIT_MAX = 1000; // API limit is 1000

export const CONTENTFUL_SPACE_ID = process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID;
export const CONTENTFUL_CRYPTOPEDIA_SPACE_ID =
  process.env.NEXT_PUBLIC_CONTENTFUL_CRYPTOPEDIA_SPACE_ID;

export const CONTENTFUL_CONTENT_TYPES_V1 = {
  HEADER: "homepageHeader",
  FOOTER: "footerGeminiCom",
  HOME_PAGE: "homepage"
};

export const CONTENTFUL_CONTENT_TYPES = {
  BLOG_POST: "blogPost",
  BLOG_AUTHOR: "author",
  CRYPTOPEDIA_ARTICLE: "cryptopediaPost",
  CRYPTOPEDIA_TOPIC: "cryptopediaTopic",
  CRYPTOPEDIA_CATEGORY: "cryptopediaCategory",
  CRYPTOPEDIA_STORY: "cryptopediaStory",
  CRYPTOPEDIA_AUTHOR: "cryptopediaAuthor",
  CRYPTOPEDIA_GLOSSARY: "cryptopediaGlossary",
  CRYPTOPEDIA_COIN_PAGE_SLUG: "coinPageSlug",
  DERIVATIVES_LEGAL_SECTION: "legalDerivativesArticlesList",
  NEWS_POST: "news",
  COIN_DETAIL: "coinDetail",
  AREA_OF_AVAILABILITY: "areaOfAvailability",
  LEGAL_PAGE: "legalPage",
  LEGAL_SECTION: "legalArticles",
  FEES_PAGE: "feesPage",
  GUSD_REPORTS: "gusdAttestation",
  ANNOUCEMENTS: "announcement",
  PROMO_CONDITIONS_LINK: "promoConditionsLink",
  FAQ_SECTION: "faqPageSnippet",
  PDF_PAGE: "pdfPage",
  INSTITUTIONAL_INSIGHTS: "institutionalInsights"
};

export const CONTENTFUL_INSTITUTIONAL_INSIGHT_QUERY = {
  content_type: CONTENTFUL_CONTENT_TYPES.INSTITUTIONAL_INSIGHTS,
  limit: CONTENTFUL_REQUEST_LIMIT,
  order: CONTENTFUL_DEFAULT_SORT
};

export const CONTENTFUL_BLOG_POST_QUERY = {
  content_type: CONTENTFUL_CONTENT_TYPES.BLOG_POST,
  limit: CONTENTFUL_REQUEST_LIMIT,
  order: CONTENTFUL_DEFAULT_SORT
};

export const CONTENTFUL_CONTENT_BODY = {
  TEXT: "text",
  PARAGRAPH: "paragraph",
  EMBEDDED_ASSET_BLOCK: "embedded-asset-block",
  EMBEDDED_ENTRY_BLOCK: "embedded-entry-block"
};
